import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../../base/BaseComponent';
import { getAjaxhelper } from 'src/utils';
import Slider from 'react-slick';

export interface HotelImagesProps extends BaseComponentProps {
    hotelCode: number;
    lang: string;
}
export interface HotelImagesState extends BaseComponentState {
    hotel: any;
    requesting: boolean;
    images: string[];
}

export class HotelImages extends BaseComponent<HotelImagesProps, HotelImagesState> {

    constructor(props: HotelImagesProps) {
        super(props);
        this.state = {
            hotel: {}, requesting: true, images: []
        };
    }

    getData = () => {
        getAjaxhelper().post(`/dynamics/hb-api/hotel-detail`, {
            lang: this.props.lang,
            hotelCode: this.props.hotelCode
        }).then(
            (hotel: any) => {
                let imgs: string[] = [];
                if ((hotel.HotelImageSumaryData)) {
                    for (let a of hotel.HotelImageSumaryData) {
                        imgs.push(a.path);
                    }
                }
                this.setState({ requesting: false, hotel, images: imgs });
            }).catch((exc) => { console.error('error: ', exc); });
    }

    componentDidMount() {
        this.getData();
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let banner: any = '';
        let imageGaleriesType = [];
        let slide = [];
        let settings = {
            dots: false,
            infinite: true,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            pauseOnHover: true,
            // lazyLoad: true,
            fade: false
        };
        if (this.state.requesting === false) {
            if ((this.state.hotel.HotelImageSumaryData) && this.state.hotel.HotelImageSumaryData!.length > 0) {
                let images: any[] | any = this.state.hotel.HotelImageSumaryData;
                banner = images[0].path ? images[0].path : '';
                let ketemu = 0;

                for (let image of images) {
                    if (image.ImageType.code === 'GEN') {
                        banner = image.path;
                        ketemu = 1;
                    } else {
                        banner = image.path;
                    }
                    if (ketemu === 1) {
                        break;
                    }
                }
                let idxImageType: { [nama: string]: string[] } = {};
                for (let image of images) {
                    if (!idxImageType[image.ImageType.description]) {
                        idxImageType[image.ImageType.description] = [];
                    }
                    idxImageType[image.ImageType.description].push(image.path);
                }
                // ======== FIX tinggi_banner harus dicari =========== 
                // let tinggiBanner = 500;
                let jumlahImageType = Object.keys(idxImageType).length;
                if (jumlahImageType === 0) {
                    jumlahImageType = 1;
                }
                let ti = ((500 + 10) / jumlahImageType) - 10;
                for (let a of Object.keys(idxImageType)) {
                    imageGaleriesType.push(
                        <div
                            className='hotel-images-child'
                            style={{
                                height: ti,
                                backgroundImage: `url("${idxImageType[a][0]}")`,
                            }}
                            onClick={() => {
                                this.setStateHelper(st => st.images = idxImageType[a]);
                            }}
                        >
                            <div style={{ textAlign: 'center', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                <h4
                                    style={{
                                        color: '#ffffff',
                                        textAlign: 'center',
                                        height: '100%',
                                        lineHeight: `${ti}px`,
                                    }}
                                > {a}
                                </h4>
                            </div>
                        </div>
                    );
                }

            }
            let imgLop = 0;
            for (let a of this.state.images!) {
                imgLop++;
                slide.push(
                    <div>
                        <div className='hotel-image-slider' key={`image${imgLop}`} style={{ backgroundImage: `url("${a}")`, width: '100%' }}>
                            <div className="container home-banner" />
                        </div>
                    </div>

                );
            }
        }
        return (
            <div  >
                <div className='hotel-image-slider' style={{ backgroundImage: `url("https://photos.hotelbeds.com/giata/bigger/${banner}")` }} >
                    <Slider className='slick-hotel-detail' {...settings}>
                        {slide}
                    </Slider>
                </div>

                <div className='hotel-image-list' >
                    <div className="" style={{ paddingLeft: 10 }} >
                        {imageGaleriesType}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/hotels/details/HotelImages.tsx